// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowPopper_root__ugnbh","arrow":"ArrowPopper_arrow__dp_ZJ","pop":"ArrowPopper_pop__eef5t"};